import { createSelector } from "@reduxjs/toolkit";
import selectDomainGym from "./selectDomainGym";

export default createSelector(selectDomainGym, ({ pages }) => pages.find((p) => p.type === "sign_up"));
